import React from "react";

const IconCollpasedMenu = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M6.5 12.0127L10.5 8.0127L6.5 4.0127"
        stroke="#808089"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconCollpasedMenu;
